(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-section-with-graphic-cards"]) return;
  try {
    


  function initializeSmibVendorFilters(root = document) {
    const filters = root.querySelectorAll('[data-smib-vendor-filter]');

    filters.forEach((filter) => {
      if (filter.dataset.smibVendorInitialized === 'true') return;

      filter.dataset.smibVendorInitialized = 'true';

      const parameter =
        filter.dataset.filterParameter || 'filter.p.vendor';
      const currentUrl = new URL(window.location.href);
      const currentValues = currentUrl.searchParams
        .getAll(parameter)
        .map((value) => value.toLowerCase());

      filter.querySelectorAll('[data-vendor-value]').forEach((link) => {
        const vendorValue = link.dataset.vendorValue || '';
        const targetUrl = new URL(currentUrl.href);

        /*
          Houd de huidige collectie, sortering en andere actieve filters vast.
          Alleen de vendor en pagination worden aangepast.
        */
        targetUrl.searchParams.delete('page');
        targetUrl.searchParams.delete(parameter);

        if (vendorValue) {
          targetUrl.searchParams.set(parameter, vendorValue);
        }

        targetUrl.hash = '';
link.href = `${targetUrl.pathname}${targetUrl.search}`;

        const isActive = vendorValue
          ? currentValues.includes(vendorValue.toLowerCase())
          : currentValues.length === 0;

        link.classList.toggle('is-active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeSmibVendorFilters(),
      { once: true }
    );
  } else {
    initializeSmibVendorFilters();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeSmibVendorFilters(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-grid-smib"]) return;
  try {
    


  function initializeSmibVendorFilters(root = document) {
    const filters = root.querySelectorAll('[data-smib-vendor-filter]');

    filters.forEach((filter) => {
      if (filter.dataset.smibVendorInitialized === 'true') return;

      filter.dataset.smibVendorInitialized = 'true';

      const parameter =
        filter.dataset.filterParameter || 'filter.p.vendor';
      const currentUrl = new URL(window.location.href);
      const currentValues = currentUrl.searchParams
        .getAll(parameter)
        .map((value) => value.toLowerCase());

      filter.querySelectorAll('[data-vendor-value]').forEach((link) => {
        const vendorValue = link.dataset.vendorValue || '';
        const targetUrl = new URL(currentUrl.href);

        /*
          Houd de huidige collectie, sortering en andere actieve filters vast.
          Alleen de vendor en pagination worden aangepast.
        */
        targetUrl.searchParams.delete('page');
        targetUrl.searchParams.delete(parameter);

        if (vendorValue) {
          targetUrl.searchParams.set(parameter, vendorValue);
        }

        targetUrl.hash = '';
link.href = `${targetUrl.pathname}${targetUrl.search}`;

        const isActive = vendorValue
          ? currentValues.includes(vendorValue.toLowerCase())
          : currentValues.length === 0;

        link.classList.toggle('is-active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeSmibVendorFilters(),
      { once: true }
    );
  } else {
    initializeSmibVendorFilters();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeSmibVendorFilters(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-grid"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.smib-shop-tabs__link');

    tabs.forEach((tab) => {
      const tabUrl = tab.getAttribute('href');

      if (!tabUrl) return;

      try {
        const parsedUrl = new URL(tabUrl, window.location.origin);

        if (parsedUrl.pathname === window.location.pathname) {
          tab.classList.add('is-active');
        }
      } catch (error) {
        return;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function initializeSmibVendorFilters(root = document) {
    const filters = root.querySelectorAll('[data-smib-vendor-filter]');

    filters.forEach((filter) => {
      if (filter.dataset.smibVendorInitialized === 'true') return;

      filter.dataset.smibVendorInitialized = 'true';

      const parameter =
        filter.dataset.filterParameter || 'filter.p.vendor';
      const currentUrl = new URL(window.location.href);
      const currentValues = currentUrl.searchParams
        .getAll(parameter)
        .map((value) => value.toLowerCase());

      filter.querySelectorAll('[data-vendor-value]').forEach((link) => {
        const vendorValue = link.dataset.vendorValue || '';
        const targetUrl = new URL(currentUrl.href);

        /*
          Houd de huidige collectie, sortering en andere actieve filters vast.
          Alleen de vendor en pagination worden aangepast.
        */
        targetUrl.searchParams.delete('page');
        targetUrl.searchParams.delete(parameter);

        if (vendorValue) {
          targetUrl.searchParams.set(parameter, vendorValue);
        }

        targetUrl.hash = '';
        link.href = `${targetUrl.pathname}${targetUrl.search}`;

        const isActive = vendorValue
          ? currentValues.includes(vendorValue.toLowerCase())
          : currentValues.length === 0;

        link.classList.toggle('is-active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeSmibVendorFilters(),
      { once: true }
    );
  } else {
    initializeSmibVendorFilters();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeSmibVendorFilters(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smib-graphic-tee-product"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('smib-product')) {

    customElements.define(
      'smib-product',
      class SmibProduct extends HTMLElement {

        connectedCallback() {

          if (this.dataset.initialized === 'true') {
            return;
          }

          this.dataset.initialized = 'true';

          this.dialog =
            this.querySelector('[data-smib-media-dialog]');

          this.dialogImage =
            this.querySelector('[data-smib-dialog-image]');

          this.openButtons =
            this.querySelectorAll('[data-smib-media-open]');

          this.closeButton =
            this.querySelector('[data-smib-media-close]');


          this.openButtons.forEach((button) => {

            button.addEventListener(
              'click',
              () => this.openImage(button)
            );

          });


          this.closeButton?.addEventListener(
            'click',
            () => this.closeImage()
          );


          this.dialog?.addEventListener(
            'click',
            (event) => {

              if (event.target === this.dialog) {
                this.closeImage();
              }

            }
          );


          this.dialog?.addEventListener(
            'cancel',
            (event) => {

              event.preventDefault();
              this.closeImage();

            }
          );


          this.initSlider();
          this.initInformationTabs();

        }


        initSlider() {

          const track =
            this.querySelector('[data-smib-slider-track]');

          const slides =
            Array.from(
              this.querySelectorAll('[data-smib-slide]:not([hidden])')
            );

          const previousButton =
            this.querySelector('[data-smib-slider-prev]');

          const nextButton =
            this.querySelector('[data-smib-slider-next]');

          const currentCounter =
            this.querySelector('[data-smib-slider-current]');


          if (!track || slides.length === 0) {
            return;
          }


          let activeIndex = 0;
          let scrollTimer;
          let resizeTimer;


          const isDesktop = () => {
            return window.innerWidth >= 750;
          };


          const visibleCount = () => {
            return isDesktop() ? 2 : 1;
          };


          const maxIndex = () => {

            return Math.max(
              0,
              slides.length - visibleCount()
            );

          };


          const updateCounter = () => {

            if (!currentCounter) {
              return;
            }


            if (isDesktop()) {

              const firstVisible =
                activeIndex + 1;

              const lastVisible =
                Math.min(
                  activeIndex + 2,
                  slides.length
                );


              if (firstVisible === lastVisible) {

                currentCounter.textContent =
                  String(firstVisible);

              } else {

                currentCounter.textContent =
                  `${firstVisible}–${lastVisible}`;

              }

            } else {

              currentCounter.textContent =
                String(activeIndex + 1);

            }

          };


          const updateUi = () => {

            activeIndex =
              Math.max(
                0,
                Math.min(
                  activeIndex,
                  maxIndex()
                )
              );


            updateCounter();


            if (previousButton) {
              previousButton.disabled =
                activeIndex <= 0;
            }


            if (nextButton) {
              nextButton.disabled =
                activeIndex >= maxIndex();
            }

          };


          const setIndex = (
            index,
            behavior = 'smooth'
          ) => {

            activeIndex =
              Math.max(
                0,
                Math.min(
                  index,
                  maxIndex()
                )
              );


            const target =
              slides[activeIndex];


            if (!target) {
              return;
            }


            track.scrollTo({
              left: target.offsetLeft,
              behavior
            });


            updateUi();

          };


          previousButton?.addEventListener(
            'click',
            () => {
              setIndex(activeIndex - 1);
            }
          );


          nextButton?.addEventListener(
            'click',
            () => {
              setIndex(activeIndex + 1);
            }
          );


          track.addEventListener(
            'scroll',
            () => {

              window.clearTimeout(scrollTimer);


              scrollTimer =
                window.setTimeout(
                  () => {

                    let closestIndex = 0;
                    let closestDistance = Infinity;


                    slides.forEach(
                      (slide, index) => {

                        const distance =
                          Math.abs(
                            slide.offsetLeft -
                            track.scrollLeft
                          );


                        if (distance < closestDistance) {

                          closestDistance =
                            distance;

                          closestIndex =
                            index;

                        }

                      }
                    );


                    activeIndex =
                      Math.min(
                        closestIndex,
                        maxIndex()
                      );


                    updateUi();

                  },
                  60
                );

            },
            {
              passive: true
            }
          );


          window.addEventListener(
            'resize',
            () => {

              window.clearTimeout(resizeTimer);


              resizeTimer =
                window.setTimeout(
                  () => {

                    setIndex(
                      activeIndex,
                      'auto'
                    );

                  },
                  100
                );

            }
          );


          updateUi();

        }


        initInformationTabs() {

          this
            .querySelectorAll(
              '[data-smib-information-tabs]'
            )
            .forEach((tabsRoot) => {

              const tabs =
                Array.from(
                  tabsRoot.querySelectorAll(
                    '[data-smib-information-tab]'
                  )
                );


              const panels =
                Array.from(
                  tabsRoot.querySelectorAll(
                    '[data-smib-information-panel]'
                  )
                );


              if (!tabs.length || !panels.length) {
                return;
              }


              const activateTab =
                (
                  selectedTab,
                  moveFocus = false
                ) => {

                  const selectedKey =
                    selectedTab.dataset.smibInformationTab;


                  tabs.forEach((tab) => {

                    const active =
                      tab === selectedTab;


                    tab.classList.toggle(
                      'is-active',
                      active
                    );


                    tab.setAttribute(
                      'aria-selected',
                      active ? 'true' : 'false'
                    );


                    tab.tabIndex =
                      active ? 0 : -1;

                  });


                  panels.forEach((panel) => {

                    const active =
                      panel.dataset.smibInformationPanel ===
                      selectedKey;


                    panel.hidden =
                      !active;


                    if (active) {
                      panel.scrollTop = 0;
                    }

                  });


                  if (moveFocus) {
                    selectedTab.focus();
                  }

                };


              tabs.forEach(
                (tab, index) => {

                  tab.addEventListener(
                    'click',
                    () => activateTab(tab)
                  );


                  tab.addEventListener(
                    'keydown',
                    (event) => {

                      if (
                        ![
                          'ArrowLeft',
                          'ArrowRight',
                          'Home',
                          'End'
                        ].includes(event.key)
                      ) {
                        return;
                      }


                      event.preventDefault();


                      let nextIndex = index;


                      if (event.key === 'ArrowLeft') {

                        nextIndex =
                          (
                            index -
                            1 +
                            tabs.length
                          ) %
                          tabs.length;

                      }


                      if (event.key === 'ArrowRight') {

                        nextIndex =
                          (
                            index +
                            1
                          ) %
                          tabs.length;

                      }


                      if (event.key === 'Home') {
                        nextIndex = 0;
                      }


                      if (event.key === 'End') {
                        nextIndex =
                          tabs.length - 1;
                      }


                      activateTab(
                        tabs[nextIndex],
                        true
                      );

                    }
                  );

                }
              );


              const initialTab =
                tabs.find(
                  (tab) =>
                    tab.getAttribute(
                      'aria-selected'
                    ) === 'true'
                ) || tabs[0];


              activateTab(initialTab);

            });

        }


        openImage(button) {

          if (!this.dialog || !this.dialogImage) {
            return;
          }


          this.dialogImage.src =
            button.dataset.fullSrc || '';

          this.dialogImage.alt =
            button.dataset.alt || '';


          if (
            typeof this.dialog.showModal ===
            'function'
          ) {

            this.dialog.showModal();

          } else {

            this.dialog.setAttribute(
              'open',
              ''
            );

          }

        }


        closeImage() {

          if (!this.dialog) {
            return;
          }


          if (
            typeof this.dialog.close ===
            'function'
          ) {

            this.dialog.close();

          } else {

            this.dialog.removeAttribute(
              'open'
            );

          }

        }

      }
    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smib-product-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('smib-product-page')) return;

    class SmibProductPage extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.smib-product-section');
        this.productData = this.readProductData();
        this.variants = this.productData?.variants || [];
        this.activeMediaIndex = 0;

        this.form = this.querySelector('[data-smib-product-form]');
        this.variantIdInput = this.querySelector('[data-smib-variant-id]');
        this.optionInputs = Array.from(this.querySelectorAll('[data-smib-option-input]'));
        this.mediaTrack = this.querySelector('[data-smib-media-track]');
        this.mediaItems = Array.from(this.querySelectorAll('[data-smib-media]'));
        this.thumbnails = Array.from(this.querySelectorAll('[data-smib-thumbnail]'));
        this.currentCounter = this.querySelector('[data-smib-current]');
        this.previousButton = this.querySelector('[data-smib-prev]');
        this.nextButton = this.querySelector('[data-smib-next]');
        this.quantityInput = this.querySelector('[data-smib-quantity-input]');
        this.addButton = this.querySelector('[data-smib-add-button]');
        this.addLabel = this.querySelector('[data-smib-add-label]');
        this.addPrice = this.querySelector('[data-smib-add-price]');
        this.priceCurrent = this.querySelector('[data-smib-price-current]');
        this.priceCompare = this.querySelector('[data-smib-price-compare]');
        this.saleBadge = this.querySelector('[data-smib-sale-badge]');
        this.availability = this.querySelector('[data-smib-availability]');
        this.availabilityText = this.querySelector('[data-smib-availability-text]');
        this.sku = this.querySelector('[data-smib-sku]');
        this.lightbox = this.querySelector('[data-smib-lightbox]');
        this.lightboxImage = this.querySelector('[data-smib-lightbox-image]');
        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
        this.scrollTimer = null;

        this.bindEvents();
        this.setMedia(0, false);
        this.refreshVariantState();
      }

      readProductData() {
        const script = this.section?.querySelector('[data-smib-product-json]');
        if (!script) return null;

        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          console.error('SMIB product data kon niet worden gelezen.', error);
          return null;
        }
      }

      bindEvents() {
        this.optionInputs.forEach((input) => {
          input.addEventListener('change', () => this.handleOptionChange(input));
        });

        this.thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => {
            this.setMedia(Number(thumbnail.dataset.index || 0));
          });
        });

        this.previousButton?.addEventListener('click', () => {
          this.setMedia(this.activeMediaIndex - 1);
        });

        this.nextButton?.addEventListener('click', () => {
          this.setMedia(this.activeMediaIndex + 1);
        });

        this.mediaTrack?.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setMedia(this.activeMediaIndex - 1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.setMedia(this.activeMediaIndex + 1);
          }
        });

        this.mediaTrack?.addEventListener(
          'scroll',
          () => {
            if (!this.mobileMediaQuery.matches) return;

            window.clearTimeout(this.scrollTimer);
            this.scrollTimer = window.setTimeout(() => {
              const closestIndex = this.mediaItems.reduce((bestIndex, item, index) => {
                const bestDistance = Math.abs(this.mediaItems[bestIndex].offsetLeft - this.mediaTrack.scrollLeft);
                const currentDistance = Math.abs(item.offsetLeft - this.mediaTrack.scrollLeft);
                return currentDistance < bestDistance ? index : bestIndex;
              }, 0);

              this.updateMediaUi(closestIndex);
            }, 80);
          },
          { passive: true }
        );

        this.querySelector('[data-smib-quantity-minus]')?.addEventListener('click', () => this.changeQuantity(-1));
        this.querySelector('[data-smib-quantity-plus]')?.addEventListener('click', () => this.changeQuantity(1));

        this.querySelectorAll('[data-smib-zoom]').forEach((button) => {
          button.addEventListener('click', () => this.openLightbox(button));
        });

        this.querySelector('[data-smib-lightbox-close]')?.addEventListener('click', () => this.closeLightbox());

        this.lightbox?.addEventListener('click', (event) => {
          if (event.target === this.lightbox) this.closeLightbox();
        });

        this.lightbox?.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeLightbox();
        });
      }

      getSelectedOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset[data-option-position]'));

        return fieldsets.map((fieldset) => {
          const selected = fieldset.querySelector('[data-smib-option-input]:checked');
          return selected?.value || '';
        });
      }

      findVariant(options = this.getSelectedOptions()) {
        return this.variants.find((variant) => {
          return variant.options.every((value, index) => value === options[index]);
        });
      }

      handleOptionChange(input) {
        const valueTarget = this.querySelector(`[data-smib-option-value="${input.dataset.optionPosition}"]`);
        if (valueTarget) valueTarget.textContent = input.value;

        this.refreshVariantState();
      }

      refreshVariantState() {
        const variant = this.findVariant();
        this.updateOptionAvailability();

        if (!variant) {
          this.updateUnavailableState();
          return;
        }

        if (this.variantIdInput) {
          this.variantIdInput.value = String(variant.id);
          this.variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', currentUrl.toString());

        this.updatePrice(variant);
        this.updateAvailability(variant);
        this.updateQuantityRules(variant);

        if (this.sku) this.sku.textContent = variant.sku || '—';

        if (variant.featuredMediaId) {
          const mediaIndex = this.mediaItems.findIndex((item) => Number(item.dataset.mediaId) === Number(variant.featuredMediaId));
          if (mediaIndex >= 0) this.setMedia(mediaIndex);
        }

        this.dispatchEvent(
          new CustomEvent('smib:variant-change', {
            bubbles: true,
            detail: { variant }
          })
        );
      }

      updateOptionAvailability() {
        const selectedOptions = this.getSelectedOptions();
        const fieldsets = Array.from(this.querySelectorAll('fieldset[data-option-position]'));

        fieldsets.forEach((fieldset, optionIndex) => {
          const inputs = Array.from(fieldset.querySelectorAll('[data-smib-option-input]'));

          inputs.forEach((input) => {
            const candidateOptions = [...selectedOptions];
            candidateOptions[optionIndex] = input.value;

            const hasMatchingVariant = this.variants.some((variant) => {
              return variant.available && variant.options.every((value, index) => value === candidateOptions[index]);
            });

            input.disabled = !hasMatchingVariant;
            input.nextElementSibling?.classList.toggle('is-unavailable', !hasMatchingVariant);
          });
        });
      }

      updateUnavailableState() {
        if (this.addButton) this.addButton.disabled = true;
        if (this.addLabel) this.addLabel.textContent = 'Niet beschikbaar';
        if (this.addPrice) this.addPrice.textContent = '';
        if (this.availability) this.availability.dataset.available = 'false';
        if (this.availabilityText) this.availabilityText.textContent = 'Deze combinatie is niet beschikbaar';
      }

      updatePrice(variant) {
        const formattedPrice = this.formatMoney(variant.price);
        const onSale = variant.compareAtPrice > variant.price;

        if (this.priceCurrent) this.priceCurrent.textContent = formattedPrice;
        if (this.addPrice) this.addPrice.textContent = formattedPrice;

        if (this.priceCompare) {
          this.priceCompare.textContent = onSale ? this.formatMoney(variant.compareAtPrice) : '';
          this.priceCompare.hidden = !onSale;
        }

        if (this.saleBadge) this.saleBadge.hidden = !onSale;
      }

      updateAvailability(variant) {
        const lowStockThreshold = Number(this.section?.dataset.lowStockThreshold || 5);
        const tracksInventory = Boolean(variant.inventoryManagement);
        const lowStock = tracksInventory && variant.inventoryQuantity > 0 && variant.inventoryQuantity <= lowStockThreshold;

        if (this.addButton) this.addButton.disabled = !variant.available;
        if (this.addLabel) this.addLabel.textContent = variant.available ? this.section?.dataset.addLabel || 'In winkelwagen' : 'Uitverkocht';
        if (this.availability) this.availability.dataset.available = variant.available ? 'true' : 'false';

        if (this.availabilityText) {
          if (!variant.available) {
            this.availabilityText.textContent = 'Niet op voorraad';
          } else if (lowStock) {
            this.availabilityText.textContent = `Nog ${variant.inventoryQuantity} beschikbaar`;
          } else {
            this.availabilityText.textContent = 'Op voorraad';
          }
        }
      }

      updateQuantityRules(variant) {
        if (!this.quantityInput) return;

        const minimum = Number(variant.quantityRule?.min || 1);
        const increment = Number(variant.quantityRule?.increment || 1);
        const maximum = variant.quantityRule?.max;

        this.quantityInput.min = String(minimum);
        this.quantityInput.step = String(increment);

        if (maximum) {
          this.quantityInput.max = String(maximum);
        } else {
          this.quantityInput.removeAttribute('max');
        }

        const currentValue = Number(this.quantityInput.value || minimum);
        this.quantityInput.value = String(Math.max(minimum, maximum ? Math.min(currentValue, maximum) : currentValue));
      }

      changeQuantity(direction) {
        if (!this.quantityInput) return;

        const minimum = Number(this.quantityInput.min || 1);
        const maximum = this.quantityInput.max ? Number(this.quantityInput.max) : Infinity;
        const step = Number(this.quantityInput.step || 1);
        const currentValue = Number(this.quantityInput.value || minimum);
        const nextValue = Math.min(maximum, Math.max(minimum, currentValue + direction * step));

        this.quantityInput.value = String(nextValue);
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      setMedia(index, smooth = true) {
        if (!this.mediaItems.length) return;

        const normalizedIndex = (index + this.mediaItems.length) % this.mediaItems.length;
        this.updateMediaUi(normalizedIndex);

        if (this.mobileMediaQuery.matches && this.mediaTrack) {
          this.mediaTrack.scrollTo({
            left: this.mediaItems[normalizedIndex].offsetLeft,
            behavior: smooth ? 'smooth' : 'auto'
          });
        }
      }

      updateMediaUi(index) {
        this.activeMediaIndex = index;

        this.mediaItems.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', active ? 'false' : 'true');

          if (!active) {
            item.querySelectorAll('video').forEach((video) => video.pause());
          }
        });

        this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
          const active = thumbnailIndex === index;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-current', active ? 'true' : 'false');
        });

        if (this.currentCounter) this.currentCounter.textContent = String(index + 1);
        this.thumbnails[index]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }

      openLightbox(button) {
        if (!this.lightbox || !this.lightboxImage) return;

        this.lightboxImage.src = button.dataset.imageSrc || '';
        this.lightboxImage.alt = button.dataset.imageAlt || '';

        if (typeof this.lightbox.showModal === 'function') {
          this.lightbox.showModal();
        } else {
          this.lightbox.setAttribute('open', '');
        }
      }

      closeLightbox() {
        if (!this.lightbox) return;

        if (typeof this.lightbox.close === 'function') {
          this.lightbox.close();
        } else {
          this.lightbox.removeAttribute('open');
        }

        if (this.lightboxImage) this.lightboxImage.src = '';
      }

      formatMoney(cents) {
        if (window.Shopify?.formatMoney) {
          return window.Shopify.formatMoney(cents, this.productData?.moneyFormat);
        }

        const currency = this.productData?.currency || 'EUR';
        return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
          style: 'currency',
          currency
        }).format(Number(cents || 0) / 100);
      }
    }

    customElements.define('smib-product-page', SmibProductPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smib-rsvp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindRsvp(root) {
      if (!root || root.dataset.smibRsvpBound === 'true') return;

      var form = root.querySelector('[data-smib-rsvp-form]');
      var success = root.querySelector('[data-smib-rsvp-success]');
      var error = root.querySelector('[data-smib-rsvp-error]');
      var submitButton = form ? form.querySelector('[type="submit"]') : null;
      var submitLabel = submitButton
        ? submitButton.querySelector('[data-smib-rsvp-submit-label]')
        : null;

      if (!form || !success || !submitButton || !submitLabel) return;

      root.dataset.smibRsvpBound = 'true';

      form.addEventListener('submit', async function (event) {
        event.preventDefault();

        if (!form.reportValidity()) return;

        var formData = new FormData(form);
        var publicKey = form.dataset.klaviyoPublicKey;
        var listId = form.dataset.klaviyoListId;
        var source = form.dataset.klaviyoSource || 'SMIB RSVP';
        var originalButtonText = submitLabel.textContent;
        var sendingLabel = submitButton.dataset.smibRsvpSendingLabel || 'Sending...';

        if (!publicKey || !listId) {
          if (error) error.hidden = false;
          return;
        }

        if (error) error.hidden = true;

        submitButton.disabled = true;
        form.setAttribute('aria-busy', 'true');
        submitLabel.textContent = sendingLabel;

        var profileAttributes = {
          email: String(formData.get('email') || '').trim(),
          subscriptions: {
            email: {
              marketing: {
                consent: 'SUBSCRIBED'
              }
            }
          }
        };

        var firstName = String(formData.get('first_name') || '').trim();
        var lastName = String(formData.get('last_name') || '').trim();

        if (firstName) profileAttributes.first_name = firstName;
        if (lastName) profileAttributes.last_name = lastName;

        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: profileAttributes
                }
              },
              custom_source: source
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId
                }
              }
            }
          }
        };

        try {
          var response = await fetch(
            'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey),
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'revision': '2026-07-15'
              },
              body: JSON.stringify(payload)
            }
          );

          if (!response.ok) throw new Error('Klaviyo request failed');

          form.hidden = true;
          form.removeAttribute('aria-busy');
          success.hidden = false;
          success.focus();
        } catch (requestError) {
          if (error) error.hidden = false;

          submitButton.disabled = false;
          form.removeAttribute('aria-busy');
          submitLabel.textContent = originalButtonText;
        }
      });
    }

    function bindAllRsvpSections(scope) {
      if (scope.matches && scope.matches('.smib-rsvp')) bindRsvp(scope);

      scope.querySelectorAll('.smib-rsvp').forEach(function (root) {
        bindRsvp(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        bindAllRsvpSections(document);
      });
    } else {
      bindAllRsvpSections(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      bindAllRsvpSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smib-transit-v26"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smib-product-file')) {
    customElements.define(
      'smib-product-file',
      class SmibProductFile extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-smib-media-dialog]');
          this.dialogImage = this.querySelector('[data-smib-dialog-image]');
          this.openButtons = this.querySelectorAll('[data-smib-media-open]');
          this.closeButton = this.querySelector('[data-smib-media-close]');

          this.openButtons.forEach((button) => {
            button.addEventListener('click', () => this.openImage(button));
          });

          this.closeButton?.addEventListener('click', () => this.closeImage());

          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) {
              this.closeImage();
            }
          });

          this.dialog?.addEventListener('cancel', (event) => {
            event.preventDefault();
            this.closeImage();
          });

          this.initSliders();
          this.initInfoDrawer();
          this.initCartStamp();
        }


        initCartStamp() {
          const stamp = this.querySelector('[data-smib-cart-stamp]');
          const buttons = Array.from(
            this.querySelectorAll(
              '.smib-clothing-editorial__purchase-details .add-to-cart-button, .smib-clothing-editorial__purchase-details button[name="add"]'
            )
          );

          if (!stamp || buttons.length === 0) {
            return;
          }

          let timer;
          const duration = Number(stamp.dataset.duration || 1100);

          buttons.forEach((button) => {
            button.addEventListener('click', () => {
              if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
                return;
              }

              window.clearTimeout(timer);
              stamp.classList.remove('is-visible');
              void stamp.offsetWidth;
              stamp.classList.add('is-visible');

              timer = window.setTimeout(() => {
                stamp.classList.remove('is-visible');
              }, duration);
            });
          });
        }

        initInfoDrawer() {
          const drawer = this.querySelector('[data-smib-info-drawer]');
          const openButtons = Array.from(this.querySelectorAll('[data-smib-drawer-open]'));
          const closeButton = this.querySelector('[data-smib-drawer-close]');
          const title = this.querySelector('[data-smib-drawer-title]');
          const panels = Array.from(this.querySelectorAll('[data-smib-drawer-panel]'));

          if (!drawer || !openButtons.length || !panels.length) {
            return;
          }

          const closeDrawer = () => {
            if (typeof drawer.close === 'function') {
              drawer.close();
            } else {
              drawer.removeAttribute('open');
            }
          };

          const openDrawer = (button) => {
            const key = button.dataset.smibDrawerOpen || '';
            const label = button.dataset.drawerLabel || 'Product info';
            let activePanel = null;

            panels.forEach((panel) => {
              const isActive = panel.dataset.smibDrawerPanel === key;
              panel.hidden = !isActive;

              if (isActive) {
                activePanel = panel;
              }
            });

            if (!activePanel) {
              return;
            }

            if (title) {
              title.textContent = label;
            }

            if (typeof drawer.showModal === 'function') {
              drawer.showModal();
            } else {
              drawer.setAttribute('open', '');
            }

            drawer.scrollTop = 0;
          };

          openButtons.forEach((button) => {
            button.addEventListener('click', () => openDrawer(button));
          });

          closeButton?.addEventListener('click', closeDrawer);

          drawer.addEventListener('click', (event) => {
            if (event.target === drawer) {
              closeDrawer();
            }
          });

          drawer.addEventListener('cancel', (event) => {
            event.preventDefault();
            closeDrawer();
          });
        }

        initSliders() {
          this.querySelectorAll('[data-smib-slider]').forEach((slider) => {
            const track = slider.querySelector('[data-smib-slider-track]');
            const slides = Array.from(slider.querySelectorAll('[data-smib-slide]'));
            const previousButton = slider.querySelector('[data-smib-slider-prev]');
            const nextButton = slider.querySelector('[data-smib-slider-next]');
            const currentCounter = slider.querySelector('[data-smib-slider-current]');
            const thumbnails = Array.from(slider.querySelectorAll('[data-smib-thumbnail]'));
            const routeDots = Array.from(slider.querySelectorAll('[data-smib-route-dot]'));
            const routeCurrent = slider.querySelector('[data-smib-route-current]');

            if (!track || slides.length === 0) {
              return;
            }

            let activeIndex = 0;
            let scrollTimer;

            const updateUi = () => {
              if (currentCounter) {
                currentCounter.textContent = String(activeIndex + 1);
              }

              if (routeCurrent) {
                routeCurrent.textContent = String(activeIndex + 1).padStart(2, '0');
              }

              previousButton?.toggleAttribute('disabled', activeIndex === 0);
              nextButton?.toggleAttribute('disabled', activeIndex === slides.length - 1);

              slides.forEach((slide, index) => {
                const distance = index - activeIndex;
                slide.classList.toggle('is-active', distance === 0);
                slide.classList.toggle('is-before', distance < 0);
                slide.classList.toggle('is-after', distance > 0);
                slide.style.setProperty('--smib-deck-distance', String(distance));
                slide.setAttribute('aria-hidden', distance === 0 ? 'false' : 'true');
              });

              thumbnails.forEach((thumbnail, index) => {
                const isActive = index === activeIndex;
                thumbnail.classList.toggle('is-active', isActive);
                thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
              });

              routeDots.forEach((dot, index) => {
                const isActive = index === activeIndex;
                dot.classList.toggle('is-active', isActive);
                dot.setAttribute('aria-current', isActive ? 'true' : 'false');
              });

              const activeThumbnail = thumbnails[activeIndex];
              activeThumbnail?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest'
              });
            };

            const setIndex = (newIndex, behavior = 'smooth') => {
              activeIndex = Math.max(0, Math.min(newIndex, slides.length - 1));

              const slide = slides[activeIndex];
              const centeredLeft = slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;

              track.scrollTo({
                left: Math.max(0, centeredLeft),
                behavior
              });

              updateUi();
            };

            previousButton?.addEventListener('click', () => {
              setIndex(activeIndex - 1);
            });

            nextButton?.addEventListener('click', () => {
              setIndex(activeIndex + 1);
            });

            thumbnails.forEach((thumbnail) => {
              thumbnail.addEventListener('click', () => {
                const thumbnailIndex = Number(thumbnail.dataset.index || 0);
                setIndex(thumbnailIndex);
              });
            });


            routeDots.forEach((dot) => {
              dot.addEventListener('click', () => {
                const routeIndex = Number(dot.dataset.index || 0);
                setIndex(routeIndex);
              });
            });

            track.addEventListener(
              'scroll',
              () => {
                window.clearTimeout(scrollTimer);

                scrollTimer = window.setTimeout(() => {
                  const trackCenter = track.scrollLeft + track.clientWidth / 2;
                  const closestIndex = slides.reduce((bestIndex, slide, index) => {
                    const bestCenter = slides[bestIndex].offsetLeft + slides[bestIndex].offsetWidth / 2;
                    const currentCenter = slide.offsetLeft + slide.offsetWidth / 2;
                    const bestDistance = Math.abs(bestCenter - trackCenter);
                    const currentDistance = Math.abs(currentCenter - trackCenter);

                    return currentDistance < bestDistance ? index : bestIndex;
                  }, 0);

                  activeIndex = closestIndex;
                  updateUi();
                }, 70);
              },
              { passive: true }
            );

            slider.addEventListener('keydown', (event) => {
              if (event.key === 'ArrowLeft') {
                event.preventDefault();
                setIndex(activeIndex - 1);
              }

              if (event.key === 'ArrowRight') {
                event.preventDefault();
                setIndex(activeIndex + 1);
              }
            });

            updateUi();
          });
        }

        openImage(button) {
          if (!this.dialog || !this.dialogImage) {
            return;
          }

          this.dialogImage.src = button.dataset.fullSrc || '';
          this.dialogImage.alt = button.dataset.alt || '';

          if (typeof this.dialog.showModal === 'function') {
            this.dialog.showModal();
          } else {
            this.dialog.setAttribute('open', '');
          }
        }

        closeImage() {
          if (!this.dialog) {
            return;
          }

          if (typeof this.dialog.close === 'function') {
            this.dialog.close();
          } else {
            this.dialog.removeAttribute('open');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
